<template lang="html">
  <section class="glosa-evidenca">
      <table class="table table-bordered table-condensed table-hover" border="1">
        <tbody>
          <tr>
            <td class="numero-item bg-color-extremidades alinhar-conteudo fonte-tabela" rowspan="15">  </td>
            <td class="descricao-sla bg-color-extremidades fonte-tabela" colspan="15">Penalidade por não execução de preventivas </td>
          </tr>

          <tr>
            <td class="detalhe-descricao fonte-tabela" colspan="15"><strong>Cada preventiva não realizada no prazo, gera glosa no respectivo valor</strong></td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Meses</td>
            <td class="meses alinhar-conteudo fonte-tabela" v-for="glosa in glosas"><strong>{{ glosa.mes.sigla }}</strong></td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Qtde de preventivas não realizadas</td>
            <td class="alinhar-conteudo fonte-tabela" v-for="item in glosas">
                <div v-if="item.quantidade">
                    <a
                        v-on:click="listaGlosasPorMes({itens: {contrato_id: contratoSelecionado.contrato_id, mes: item.mes, ano: anoSelecionado}})"
                        v-if="item.quantidade"
                        href="javascript:void(0)"
                        data-toggle="listarGlosas"
                    >
                        {{ item.quantidade }}
                    </a>
                </div>
                <div v-else-if="item.quantidade === 0">
                  {{ item.quantidade }}
                </div>

            </td>
          </tr>

          <tr>
            <td class="titulo-lateral-linha fonte-tabela" colspan="1">Valor da glosa </td>
            <td class="alinhar-conteudo fonte-tabela" v-for="item in glosas">
              <money v-model="item.moeda" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
            </td>
          </tr>

        </tbody>
    </table>
                <exibir-glosas-impressao :filtro="{ano: anoSelecionado, contrato: contratoSelecionado}" />
  </section>
</template>

<script>
import {Money} from 'v-money'
import impressaoGlosa from '../print/GlosaImpressao.vue'

export default {
  props: ['contrato', 'ano', 'fornecedor'],
  data: function () {
    return {
      anoSelecionado: Number,
      contratoSelecionado: [],
      glosas: [],
      quantidades: [],
      valores: [],
      controlerLoading: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      env: process.env
    }
  },
  mounted: function () {
    this.definePros()
    this.getGlosaFiltroAnoContrato()
  },
  components: {
    Money,
    'exibir-glosas-impressao': impressaoGlosa
  },
  watch: {
    ano: function () {
      this.definePros()
      this.getGlosaFiltroAnoContrato()
    }
  },
  methods: {
    definePros: function () {
      this.anoSelecionado = this.ano
      this.contratoSelecionado = this.contrato
    },
    getGlosaFiltroAnoContrato: function () {
      let vm = this
      this.controlerLoading = false
      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/getGlosaFiltroAnoContrato`, {
        ano: this.anoSelecionado,
        contrato_id: this.contratoSelecionado.contrato_id
      }, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      })
      .then(function (response) {
        vm.glosas = response.data
        vm.controlerLoading = true
      })
      .catch(error => {
        this.controlerLoading = true
        console.log(error)
      })
    },
    listaGlosasPorMes: function (itens) {
      this.$store.commit('setModalListaGlosasPorMes', {conteudo: itens, show: true})
    }
  }
}
</script>

<style scoped src="../../sla/css/controleApuracaoSla.css"></style>
<style scoped src="../css/tableGlosaEvidencia.css"></style>



// WEBPACK FOOTER //
// TableGlosaEvidencia.vue?4d503c18